import React, { Component } from 'react'
import classes from './technology.module.css'
import { Tabs } from '../../Component/UI/Tabs/Tabs'
import { Spinner } from '../../Component/Spinner/Spinner'

export default class Technology extends Component {

    state = {
        items: 0,
        data: [],
        width: window.innerWidth
    }

    componentDidMount() {
        
        fetch('data.json')
        .then(res => res.json())
        .then(data => {
            console.log(data.crew)
            this.setState({data: data.technology[this.state.items]})
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.items !== prevState.items) {
            fetch('data.json')
            .then(res => res.json())
            .then(data => {
                
                this.setState({data: data.technology[this.state.items]})
            }) 
        }
    }


    changeTabHandler = index => {
        console.log(index)
        console.log(this.state.items)
        this.setState({items: index})
    }

    setWindowHandler = () => {
        window.addEventListener('resize', () => this.setState({width: window.innerWidth}))
    }

    activeTabs = index => {

        let styles = null

        if (this.state.items === index) {
            return styles = {
                backgroundColor: '#fff',
                color: '#000'
                
            }
        }    
    }

    render() {
        let destinationData = <Spinner />
        

        if (this.state.data.length !== 0) {

            // this.setWindowHandler()

           destinationData = (
            
            <div className=" pt-32 pb-10 h-full" >
                <h4 className="text-white text-xl tracking-widest lg:text-4xl lg:text-left lg:pl-48 lg:pt-20"><span className=" text-blue-700 font-bold mr-4">03</span>SPACE LAUNCH 101</h4>

                <section className="lg:grid grid-cols-4 pt-20">

                    <section className="col-start-3 col-end-5">
                    <img src={this.state.data.images.portrait} alt="img" className="sm:hidden md:hidden lg:block xl:block w-4/5 h-4/5 ml-20"/>
                    <img src={this.state.data.images.landscape} alt="planet" className="mt-12 m-auto lg:h-full lg:w-full lg:mt-0 lg:hidden"/>
                    </section>

                    <section className="col-start-1 row-start-1">
                    
                    <Tabs>
                        <div className="w-full flex justify-between px-8 lg:flex-col  lg:items-center">

                            <button style={this.activeTabs(0)} 
                            className="w-14 h-14 rounded-full border-2 lg:w-28 lg:h-28 lg:mb-10"
                            onClick={() => this.changeTabHandler(0)}>1</button>

                            <button style={this.activeTabs(1)}
                            className="w-14 h-14 rounded-full border-2 lg:w-28 lg:h-28 lg:mb-10"
                            onClick={() => this.changeTabHandler(1)}>2</button>

                            <button style={this.activeTabs(2)}
                            className="w-14 h-14 rounded-full border-2 lg:w-28 lg:h-28 lg:mb-10"
                            onClick={() => this.changeTabHandler(2)}>3</button>
                        </div>
                    </Tabs>

                    </section>

                    <section className="col-start-2 row-start-1 col-span-1">
                    <div className="mt-10">
                    <h1 className="text-softGray font-barlow text-m lg:text-left lg:text-3xl">THE TERMINOLOGY...</h1>
                    <h1 className="font-Bellefair text-white text-2xl lg:text-left lg:text-2xl">{this.state.data.name.toUpperCase()}</h1>
                    <p className="text-softGray mt-5 font-barlow px-10 lg:text-left lg:text-xl lg:px-0 ">{this.state.data.description}</p>
                    </div>

                    </section>
                </section>
                
            </div>
           )
        }
        return (
            
            <div className={classes.container}>
                {destinationData}
            </div>
           
        )
    }
}
